
import FieldSampleSelect from './FieldSampleSelect';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FieldSampleDate from './FieldSampleDate';

const FieldSampleTools = () => {
    return (
        <>
            <Accordion className='accordion-style' defaultExpanded>
                <AccordionSummary
                    className='accordion-title'
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="Date Slider"
                    id="Date"
                >
                    Date
                    
                </AccordionSummary>
                <AccordionDetails>
                    <div style={{ width: '94%' }}>
                        <FieldSampleDate/>
                    </div>
                </AccordionDetails>
            </Accordion>
            <Accordion className='accordion-style' defaultExpanded>
                <AccordionSummary
                    className='accordion-title'
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="FieldSample"
                    id="FieldSample"
                >
                    <label id='fieldSampleData' htmlFor='fieldSampleData'>Field Sample Data</label>
                </AccordionSummary>
                <AccordionDetails>
                    <FieldSampleSelect/>
                </AccordionDetails>
            </Accordion>

        </>
    )
}

export default FieldSampleTools;
